import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-28fd14bc")

_pushScopeId("data-v-28fd14bc")
const _hoisted_1 = {
  class: "modal fade",
  id: "order_shop_products_modal",
  tabindex: -1,
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-lg order-products-dialog modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_3 = { class: "modal-content position-relative" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "mb-0" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-sm btn-icon",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_7 = { class: "modal-body pt-0" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "fas fa-search" }, null, -1)
const _hoisted_9 = { class: "order-product-list" }
const _hoisted_10 = { class: "order-product-image" }
const _hoisted_11 = { class: "order-product-name" }
const _hoisted_12 = { class: "order-product-price" }
const _hoisted_13 = {
  key: 0,
  class: "text-center text-muted py-10"
}
const _hoisted_14 = {
  key: 1,
  class: "text-center pb-4"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_InnerLoader, {
          loading: _ctx.loader,
          innerLoading: true
        }, null, 8, ["loading"]),
        _createVNode("div", _hoisted_4, [
          _createVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t('message.ADD')) + " " + _toDisplayString(_ctx.$t('message.PRODUCTS')), 1),
          _hoisted_6
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("form", {
            class: "order-product-search mb-4",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.searchProducts && _ctx.searchProducts(...args)), ["prevent"]))
          }, [
            _withDirectives(_createVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.search = $event)),
              type: "search",
              class: "form-control",
              placeholder: `${_ctx.$t('message.SEARCH')} ${_ctx.$t('message.PRODUCTS')}`
            }, null, 8, ["placeholder"]), [
              [_vModelText, _ctx.search]
            ]),
            _createVNode("button", {
              type: "submit",
              class: "btn btn-custom order-product-search-btn",
              disabled: _ctx.loader,
              "aria-label": _ctx.$t('message.SEARCH')
            }, [
              _hoisted_8
            ], 8, ["disabled", "aria-label"])
          ], 32),
          _createVNode("div", _hoisted_9, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.products, (item) => {
              return (_openBlock(), _createBlock("article", {
                key: item.id,
                class: "order-product-card"
              }, [
                _createVNode("div", _hoisted_10, [
                  _createVNode("img", {
                    src: _ctx.productImage(item),
                    alt: ""
                  }, null, 8, ["src"])
                ]),
                _createVNode("h3", _hoisted_11, _toDisplayString(item?.product_name_sku), 1),
                _createVNode("div", _hoisted_12, _toDisplayString(_ctx.shopPrice(item)), 1),
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-custom order-product-add",
                  disabled: _ctx.addingId === item.id,
                  onClick: ($event: any) => (_ctx.addProduct(item))
                }, [
                  _createVNode("i", {
                    class: _ctx.addingId === item.id ? 'fas fa-spinner fa-spin' : 'fas fa-plus'
                  }, null, 2),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('message.ADD')) + " " + _toDisplayString(_ctx.$t('message.PRODUCT')), 1)
                ], 8, ["disabled", "onClick"])
              ]))
            }), 128))
          ]),
          (!_ctx.loader && !_ctx.products.length)
            ? (_openBlock(), _createBlock("div", _hoisted_13, _toDisplayString(_ctx.$t('message.NO_DATA_FOUND')), 1))
            : _createCommentVNode("", true),
          (_ctx.hasMore)
            ? (_openBlock(), _createBlock("div", _hoisted_14, [
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-custom",
                  disabled: _ctx.loader,
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.loadMore && _ctx.loadMore(...args)))
                }, _toDisplayString(_ctx.$t('message.SHOW_MORE_PRODUCTS')), 9, ["disabled"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
})